import { render, staticRenderFns } from "./BillingPaymentsScreen.vue?vue&type=template&id=2e9c5d86&scoped=true&"
import script from "./BillingPaymentsScreen.vue?vue&type=script&lang=js&"
export * from "./BillingPaymentsScreen.vue?vue&type=script&lang=js&"
import style0 from "./BillingPaymentsScreen.vue?vue&type=style&index=0&id=2e9c5d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c5d86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
